/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.208.0-v202610231530-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export interface TemplateRuleInputV1String {
    /**
     * Static argument value for the rule input, if applicable. Only one of argument, inputFeatureId, inputFeatureIndex, or derivedFeatureIndex can be set.
     */
    "argument"?: string;
    /**
     * Index of the derived feature to reference as input, if applicable. Only one of argument, inputFeatureId, inputFeatureIndex, or derivedFeatureIndex can be set.
     */
    "derivedFeatureIndex"?: number;
    /**
     * Description of the rule input.
     */
    "description"?: string;
    /**
     * Unique identifier for the rule input. Omit on create.
     */
    "id"?: string;
    /**
     * ID of the input feature to reference as input, if applicable. Only one of argument, inputFeatureId, inputFeatureIndex, or derivedFeatureIndex can be set.
     */
    "inputFeatureId"?: string;
    /**
     * Index of the input feature to reference as input, if applicable. Only one of argument, inputFeatureId, inputFeatureIndex, or derivedFeatureIndex can be set.
     */
    "inputFeatureIndex"?: number;
    /**
     * Name of the rule input.
     */
    "name": string;
    /**
     * Type of the rule input.
     */
    "type": TypeEnum;
}

export const TypeEnum = {
    TEXT: 'TEXT',
    NUMERIC: 'NUMERIC',
    ITEMID: 'ITEM_ID',
    FEATUREID: 'FEATURE_ID',
    BOOLEAN: 'BOOLEAN',
    TIMESTAMPTZ: 'TIMESTAMPTZ',
    TEXTLIST: 'TEXT_LIST',
    NUMERICLIST: 'NUMERIC_LIST',
    ITEMIDLIST: 'ITEM_ID_LIST'
} as const;

export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
